import { render } from "./XiaofeiData.vue?vue&type=template&id=578f51f7&scoped=true"
import script from "./XiaofeiData.vue?vue&type=script&lang=js"
export * from "./XiaofeiData.vue?vue&type=script&lang=js"

import "./XiaofeiData.vue?vue&type=style&index=0&id=578f51f7&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-578f51f7"

export default script